"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
function ConfirmRevertButtons(props) {
    var onConfirmClicked = props.onConfirmClicked, onRevertClicked = props.onRevertClicked, isInvalid = props.isInvalid, name = props.name;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { className: "eva-confirm-revert-buttons-container" },
        !isInvalid && (react_1.default.createElement("i", { className: "implioicons-check", onMouseDown: onConfirmClicked, title: t('ITEM.CONFIRM_CHANGES'), "data-cy": "".concat(name, "-confirm") })),
        react_1.default.createElement("i", { className: "implioicons-revert", onMouseDown: onRevertClicked, title: t('ITEM.DISCARD_CHANGES'), "data-cy": "".concat(name, "-revert") })));
}
exports.default = ConfirmRevertButtons;
